const handleDecimalCheck = (event) => {
  const inputValue = event.key;
  if (/^\d$/.test(inputValue) || inputValue === '.') {
    const hasDot = event.target.value.includes('.');
    if (inputValue === '.' && hasDot) {
      event.preventDefault();
    }
  } else {
      event.preventDefault();
    }
  }
  
  export default handleDecimalCheck;